import { getUserRoles } from "shared-frontend/functions/auth";
import { createFeatureFlag } from "./featureFlags";

export const PROVISIONER_ROLE = "provisioner";

/**
 * Whether the provisioning UI is switched on: `REACT_APP_ENABLE_PROVISIONING=true` or `?test_provisioning`.
 *
 * @returns {boolean} Whether the flag is on.
 */
export const isProvisioningEnabled = createFeatureFlag( "provisioning" );

/**
 * Whether the current user gets the Provisioning menu and routes.
 *
 * Only decides what is shown: the server enforces access on every provisioning route. Reads the
 * impersonated user's roles, so an admin impersonating a provisioner sees what the provisioner sees.
 *
 * @returns {boolean} Whether the user is a provisioner and the flag is on.
 */
export const canUseProvisioning = () => isProvisioningEnabled() && getUserRoles().includes( PROVISIONER_ROLE );
